import {
  ADMIN_ACTIVITIES_SHOW_ACTIVITY_PATH,
  ADMIN_ACTIVITIES_SHOW_ACTIVITY_PATH_V2,
  ADMIN_ACTIVITIES_SHOW_ACTIVITY_SIMPLE_PATH,
  ADMIN_ACTIVITIES_SHOW_ACTIVITY_SIMPLE_PATH_V2
} from 'routes/paths'

import type { LocationType } from '../types'
import type { UserState } from 'utils/hooks/use-userInfo'
import { matchPath } from 'react-router-dom'

function getRedirectLocation(user: UserState, currentPath): LocationType {
  if (
    user.featureToggles?.paranaNotice &&
    currentPath === ADMIN_ACTIVITIES_SHOW_ACTIVITY_PATH()
  ) {
    const pathname = location.pathname
    const match = matchPath<{ activityId: string }>(pathname, {
      path: ADMIN_ACTIVITIES_SHOW_ACTIVITY_PATH()
    })
    return {
      pathname: ADMIN_ACTIVITIES_SHOW_ACTIVITY_PATH_V2(match.params.activityId)
    }
  }

  if (
    user.featureToggles?.paranaNotice &&
    currentPath === ADMIN_ACTIVITIES_SHOW_ACTIVITY_SIMPLE_PATH()
  ) {
    const pathname = location.pathname
    const match = matchPath<{ activityId: string; slug: string }>(pathname, {
      path: ADMIN_ACTIVITIES_SHOW_ACTIVITY_SIMPLE_PATH()
    })
    return {
      pathname: ADMIN_ACTIVITIES_SHOW_ACTIVITY_SIMPLE_PATH_V2(
        match.params.activityId,
        match.params.slug
      )
    }
  }

  return {
    pathname: ''
  }
}

export default getRedirectLocation
